export default __webpack_public_path__ + "select_devices.6231cbe2.png";